import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setStorage } from 'utilz';

import PageTitle from 'components/PageTitle';
import Button from 'components/Button';

import { URLS } from 'config';

import './styles.scss';
import containerActions from './actions';

class GenderPage extends React.Component {
  componentWillMount() {
    if (typeof this.props.gender !== 'boolean' && this.props.gender !== undefined) {
      // this.props.history.push(URLS.WORKING);
    }
  }
  selectGenderType = type => () => {
    this.props.sendGender(() => {
      this.props.history.push(URLS.WORKING);
    }, type);
    setStorage({
      gender: {
        gender: type
      }
    });
  };

  render() {
    return (
      <div className="page-gender">
        <PageTitle>Please select your gender</PageTitle>
        <div className="gender-types">
          <Button disabled={false} onClick={this.selectGenderType(0)}>
			Woman
          </Button>
          <Button disabled={false} onClick={this.selectGenderType(1)}>
			Man
          </Button>
        </div>
      </div>
    );
  }
}

GenderPage.propTypes = {
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  sendGender: PropTypes.func.isRequired,
  gender: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired
};

const mapStateToProps = state => ({
  gender: state.gender.gender
});

export default connect(mapStateToProps, containerActions)(GenderPage);



// WEBPACK FOOTER //
// ./src/pages/Gender/index.js